import React from 'react';
import PropTypes from 'prop-types';
import { modal } from 'react-redux-modal';
import { MessagePartnerView, StaticModalView } from '../Modals';

const CommentsCTAButtons = ({ partner, livecamId }) => {
  const onMessagePartner = (e) => {
    e.preventDefault();
    modal.add(MessagePartnerView, {
      hideTitleBar: true,
      title: '',
      size: 'large',
      partnerId: partner.id,
      partnerTitle: partner.title,
      livecamId,
    });
  };

  const onCommunityGuidelinesModal = (e) => {
    e.preventDefault();
    modal.add(StaticModalView, {
      hideTitleBar: true,
      title: '',
      size: 'large',
      contentType: 'community-guidelines',
      pageTitle: 'Community Guidelines',
    });
  };

  return (
    <div className="row disqus-box-buttons">
      <div className="col-12">
        <div className="align-items-center justify-content-center no-gutters row">
          <div className="col-12 text-center row justify-content-center">
            {(partner && partner.has_email) && (
              <div className="col-md-6 mb-2 pl-0 pr-1">
                <button
                  className="community-guidelines text-uppercase video-player-btn text-btn u-font-foundation-roman"
                  onClick={onMessagePartner}
                >
                  <div>Message Partner</div>
                </button>
              </div>
            )}
            <div className="col mb-2 pr-0 pl-1">
              <button
                className="community-guidelines text-uppercase video-player-btn text-btn u-font-foundation-roman"
                onClick={onCommunityGuidelinesModal}
              >
                <div>Community Guidelines</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CommentsCTAButtons.propTypes = {
  livecamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  partner: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    has_email: PropTypes.bool,
  }),
};

CommentsCTAButtons.defaultProps = {
  partner: null,
};

export default CommentsCTAButtons;
